import React from 'react';
import { Nav, NavItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

const tabs = [
  { name: 'general', label: '一般', path: '/settings' },
  { name: 'shopIntegrations', label: 'ショップ連携', path: '/settings/shopIntegrations' },
  { name: 'adApiAccounts', label: '広告APIアカウント', path: '/settings/adApiAccounts' },
  { name: 'productTags', label: '商品タグ', path: '/settings/productTags' },
];

export default function SettingsTabs({ activeTab }) {
  return (
    <Nav tabs className="mb-3">
      {tabs.map(({ label, name, path }) => (
        <NavItem key={name}>
          <Link 
            className={classnames('nav-link cursor-pointer', { active: activeTab === name })}
            to={path}
          >
            {label}
          </Link>
        </NavItem>
      ))}
    </Nav>
  );
}